function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Container, Button, Select } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loadNoAccessTeams } from '../actions/teams/loadNoAccessTeams';
import { loadNoAccessUserOrganisations } from '../actions/organisations/loadNoAccessUserOrganisations';
import { switchOrganisationAndTeam } from '../actions/authentication/switchOrganisationAndTeam';
import * as Styles from '../styles/NoAccess.style';
export var NoAccess = function (_React$Component) {
  _inherits(NoAccess, _React$Component);

  function NoAccess(props) {
    _classCallCheck(this, NoAccess);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.changeCurrentNoAccessOrganisation = function (e, _ref) {
      var value = _ref.value;

      _this.setState({
        currentNoAccessOrganisationId: value,
        currentNoAccessTeamId: null,
        organisationSelected: true
      });

      _this.props.loadNoAccessTeams(_this.props.productId, value);
    };

    _this.changeCurrentNoAccessTeam = function (e, _ref2) {
      var value = _ref2.value;

      _this.setState({
        currentNoAccessTeamId: value
      });
    };

    _this.setCurrentOrganisationAndTeam = function (currentNoAccessOrganisation, currentNoAccessTeam) {
      _this.props.switchOrganisationAndTeam(currentNoAccessOrganisation, currentNoAccessTeam);

      window.location.href = '/';
    };

    _this.state = {
      currentNoAccessOrganisationId: null,
      currentNoAccessTeamId: null,
      organisationSelected: false
    };
    return _this;
  }

  NoAccess.prototype.componentDidMount = function componentDidMount() {
    this.props.loadNoAccessUserOrganisations(this.props.productId);
  };

  NoAccess.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        _props$products = _props.products,
        products = _props$products === undefined ? [] : _props$products,
        noAccessOrganisations = _props.noAccessOrganisations,
        productName = _props.productName,
        noAccessTeams = _props.noAccessTeams;
    var _state = this.state,
        currentNoAccessOrganisationId = _state.currentNoAccessOrganisationId,
        currentNoAccessTeamId = _state.currentNoAccessTeamId,
        organisationSelected = _state.organisationSelected;
    var organisationOptions = [];
    var teamOptions = [];
    /* Build out org dropdown options */

    noAccessOrganisations && noAccessOrganisations.byId && Object.values(noAccessOrganisations.byId).forEach(function (organisation) {
      organisationOptions.push({
        value: organisation.organisationId.toString(),
        key: organisation.organisationId.toString(),
        text: organisation.organisationName
      });
    });
    /* Build out org dropdown options */

    /* Build out team dropdown options */

    organisationSelected && noAccessTeams && noAccessTeams.byId && Object.values(noAccessTeams.byId).forEach(function (team) {
      teamOptions.push({
        value: team.teamId.toString(),
        key: team.teamId.toString(),
        text: team.teamName,
        name: team.teamName
      });
    });
    /* Build out team dropdown options */

    var disabledButton = true;

    if (teamOptions && teamOptions.length && currentNoAccessOrganisationId && currentNoAccessTeamId) {
      disabledButton = false;
    } else if (teamOptions.length === 0 && currentNoAccessOrganisationId) {
      disabledButton = false;
    }

    return React.createElement('div', {
      className: 'page--multifaceted-bg-grey'
    }, React.createElement(Container, {
      className: 'page-container'
    }, React.createElement('div', {
      className: 'register-form'
    }, React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 10
    }, React.createElement('div', {
      className: 'callout'
    }, noAccessOrganisations && organisationOptions.length > 0 ? React.createElement(React.Fragment, null, React.createElement('h3', {
      style: Styles.subHeader
    }, 'Select an Organisation and/or Team with Access to', ' ', productName), React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 6
    }, React.createElement(Grid.Row, null, React.createElement('h4', {
      style: Styles.label
    }, 'Organisations'), React.createElement(Select, {
      style: Styles.dropdownStyle,
      onChange: this.changeCurrentNoAccessOrganisation.bind(this),
      placeholder: 'Select Organisation',
      fluid: true,
      search: true,
      selection: true,
      options: organisationOptions
    }))), teamOptions && teamOptions.length > 0 && React.createElement(Grid.Column, {
      width: 6
    }, React.createElement(Grid.Row, null, React.createElement('h4', {
      style: Styles.label
    }, 'Teams'), React.createElement(Select, {
      style: Styles.dropdownStyle,
      onChange: this.changeCurrentNoAccessTeam,
      placeholder: 'Select Team',
      fluid: true,
      search: true,
      selection: true,
      options: teamOptions
    })))), React.createElement(Button, {
      style: Styles.buttonStyle,
      onClick: function onClick() {
        return _this2.setCurrentOrganisationAndTeam(currentNoAccessOrganisationId, currentNoAccessTeamId);
      },
      disabled: disabledButton
    }, 'Apply')) : null, React.createElement('h3', {
      style: Styles.subHeader
    }, noAccessOrganisations && organisationOptions.length > 0 ? 'Alternatively you can select an available product below:' : 'Please select an available product below:'), React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Row, null, products.map(function (product) {
      var className = 'nine-dot__item';

      if (product.hasAccess) {
        return React.createElement(Grid.Column, {
          key: product.id,
          mobile: 6,
          tablet: 3,
          computer: 1
        }, React.createElement('a', {
          className: className,
          href: product.url,
          target: '_blank',
          rel: 'noopener noreferrer'
        }, React.createElement('div', {
          className: 'nine-dot-menu__icon',
          style: Styles.nineDotMenuItem
        }, React.createElement('img', {
          src: product.iconLogoLocation,
          alt: product.name,
          style: Styles.nineDotMenuImage
        })), React.createElement('span', {
          style: Styles.productLabel
        }, product.name)));
      } else {
        return null;
      }
    })))))))));
  };

  return NoAccess;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    products: state.auth.products,
    noAccessOrganisations: state.auth.noAccessUserOrganisations,
    noAccessTeams: state.auth.noAccessUserTeams && state.auth.noAccessUserTeams.order.length > 0 && state.auth.noAccessUserTeams,
    currentOrganisation: state.auth.organisations.byId[state.auth.organisations.currentOrganisation],
    currentTeam: state.auth.teams.currentTeam ? state.auth.teams.byId[state.auth.teams.currentTeam] : null
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loadNoAccessTeams: loadNoAccessTeams,
    switchOrganisationAndTeam: switchOrganisationAndTeam,
    loadNoAccessUserOrganisations: loadNoAccessUserOrganisations
  }, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NoAccess));